import { IconButton, Input, InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import React from 'react';
import { connect } from 'react-redux';
import { setDefectFilterKey, setSelection } from '../../store/actions';
import SelectDialog from '../../components/SelectDialog';
import DefectTable from './defect';
import SelectedChip from './selected';


const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
  },
  addIcon: {
    marginRight: theme.spacing(1)
  },
  done: {
    textDecoration: 'line-through',
    color: theme.palette.text.secondary
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  }
}));

function SelectDefect(props) {  
  const classes = useStyles();
  if (!props.defects) return null;
  return (
    <SelectDialog
      open={props.open}
      title={props.title || "Seçim Yapınız"}
      onClose={props.onClose}
      onEntering={() => props.setDefectFilterKey("")}
      actions={false}
      SearchField={
        <div className={classes.fields}>
          <Input
            onChange={(event) => props.setDefectFilterKey(event.target.value)}
            value={props.defects.filterKey}
            endAdornment={<InputAdornment position="end">
              <IconButton
                edge="end">
                <SearchIcon />
              </IconButton>
            </InputAdornment>}
            aria-describedby="standard-weight-helper-text"
            placeholder="Hizmet kodu ya da adını giriniz..."
          />
        </div>
      }
      SelectedItems={<SelectedChip />}
    >
      <DefectTable/> 
    </SelectDialog>
  );
}

const mapStateToProps = (state) => ({
  defects: state.defectReducer,
});

const mapDispatchToProps = {
  setSelection: setSelection,
  setDefectFilterKey: setDefectFilterKey
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectDefect)
